import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';
import { MaskedInputFieldReduxFormWrapper } from '../reduxFormFields';
import { required, format } from 'redux-form-validators';
import PhoneVerificationContainer from './container';
import PhoneVerificationUI from './ui';
import { CODE_ERROR, phoneNumberMask, PHONE_ERROR, validatePhoneNumber, verificationCodeMask, } from './utils';
const phoneValidate = [
    required({ message: PHONE_ERROR }),
    validatePhoneNumber(),
];
export const PhoneInputField = props => {
    return (_jsx(Field, { guide: false, inputLabel: '+1', mask: phoneNumberMask, component: MaskedInputFieldReduxFormWrapper, validate: phoneValidate, ...props }));
};
const codeValidate = [
    required({ message: CODE_ERROR }),
    format({ with: /[0-9]{6}/i, message: CODE_ERROR }),
];
export const CodeInputField = props => {
    return (_jsx(Field, { guide: false, mask: verificationCodeMask, component: MaskedInputFieldReduxFormWrapper, validate: codeValidate, ...props }));
};
const FORM_NAME = 'PhoneVerification';
const PhoneVerificationReduxForm = connect((state, ownProps) => ({
    phoneValue: _.get(state, `form.${FORM_NAME}.values.phone`),
    phoneError: _.get(state, `form.${FORM_NAME}.syncErrors.phone`),
    codeValue: _.get(state, `form.${FORM_NAME}.values.code`),
    codeError: _.get(state, `form.${FORM_NAME}.syncErrors.code`),
    initialValues: {
        phone: _.get(ownProps, 'latestPhone.number', ''),
    },
}))(reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
})(PhoneVerificationContainer));
export default props => (_jsx(PhoneVerificationReduxForm, { ...props, children: phoneVerificationProps => (_jsx(PhoneVerificationUI, { ...phoneVerificationProps, renderPhoneInputField: _jsx(PhoneInputField, { elmId: 'verify_phone', hideLabel: true, name: 'phone', onChange: phoneVerificationProps.onChangePhoneInput, compact: phoneVerificationProps.compact }), renderCodeInputField: _jsx(CodeInputField, { elmId: 'verify_code', hideLabel: true, name: 'code', onChange: phoneVerificationProps.onChangeCodeInput, compact: phoneVerificationProps.compact }) })) }));
//# sourceMappingURL=reduxFormContainer.js.map